import { observer } from "mobx-react";
import React from "react";
import "./FolderList.scss";
import Overlay from "app/components/Overlay/Overlay";
import FolderStore from "app/stores/FolderStore";

type Props = {
    user: ?User,
};

@observer
export default class FolderList extends React.Component<Props> {

    setInputRef = (element: ?HTMLInputElement) => {
        if (!element) {
            return null;
        }

        element.select()
        element.focus();
    }

    handleSelect(e, folder) {
        e.preventDefault();
        FolderStore.select(folder);
    }

    handleStartEditing(e, folder) {
        e.preventDefault();
        FolderStore.startEditing(folder);
    }

    handleCancelEditing(e) {
        e.preventDefault();
        FolderStore.cancelEditing();
    }

    handleStartAdding(e) {
        e.preventDefault();
        FolderStore.startAdding();
    }    

    handleCancelAdding(e) {
        e.preventDefault();
        FolderStore.cancelAdding();
    }

    handleStartDeleting(e, folder) {
        e.preventDefault();
        FolderStore.startDeleting(folder);
    }

    handleCancelDeleting(e) {
        e.preventDefault();
        FolderStore.cancelDeleting();
    }

    handleChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
        FolderStore.setName(e.target.value);
    }

    renderDelete() {
        return (
            <div className="VideoFolderMove">
                <Overlay active={true} onClick={this.handleCancelDeleting}/>

                <div className="VideoFolderMove__body">
                    <button
                        type="button"
                        onClick={this.handleCancelDeleting}
                        className="VideoFolderMove__cancel"
                    >
                        <i className="fa fa-remove" />
                    </button>

                    <div className="VideoFolderMove__title">
                        Are you sure you want to delete <strong>{FolderStore.name}</strong> folder?
                    </div>
                    <div className="VideoFolderMove__actions">
                        <button className="btn btn-danger" onClick={this.handleCancelDeleting}>No</button>
                        <button className="btn btn-default" onClick={FolderStore.delete}>Yes</button>
                    </div>
                </div>
            </div>
        );
    }

    render () {

        return (
            <div className="FolderList">
                <ul>
                    <li key="add" className="FolderList__add">
                        { FolderStore.isAdding 
                            ? <span className="FolderList__input">
                                <input value={FolderStore.name} onChange={this.handleChange} disabled={FolderStore.isUpdating} ref={this.setInputRef}></input>
                                { FolderStore.isUpdating
                                    ? <i className="fa fa-check"></i>
                                    : <span>
                                        <button className="btn btn-link" onClick={(e) => FolderStore.save()}><i className="fa fa-check"></i></button>
                                        <button className="btn btn-link" onClick={(e) => this.handleCancelAdding(e)}><i className="fa fa-times"></i></button>
                                    </span>
                                }
                            </span>
                            : <a onClick={(e) => this.handleStartAdding(e)}><i className="fa fa-plus"></i>Add folder</a>
                        }
                        
                    </li>
                    { FolderStore.folders.map((folder) => {
                        return <li  key={folder.id} className="FolderList__folder">
                            { FolderStore.isEditing && FolderStore.changingId === folder.id // && folder.id !== null
                                ? <span className="FolderList__input">
                                    <input value={FolderStore.name} onChange={this.handleChange} disabled={FolderStore.isUpdating} ref={this.setInputRef}></input>
                                    { FolderStore.isUpdating
                                        ? <i className="fa fa-check"></i>
                                        : <span>
                                            <button className="btn btn-link" onClick={(e) => FolderStore.save()}><i className="fa fa-check"></i></button>
                                            <button className="btn btn-link" onClick={(e) => this.handleCancelEditing(e)}><i className="fa fa-times"></i></button>
                                        </span>
                                    }
                                </span>
                                : <span>
                                    { folder.id === FolderStore.selectedId 
                                        ? <span><i className="fa fa-folder-open"></i> {folder.name} ({folder.video_count})</span>
                                        : <a onClick={(e) => this.handleSelect(e, folder)}><i className="fa fa-folder"></i> {folder.name} ({folder.video_count})</a>
                                    }                                    
                                    { folder.id !== null && <a className="FolderList__delete" onClick={(e) => this.handleStartDeleting(e, folder)}><i className="fa fa-trash"></i></a> }
                                    { folder.id !== null && <a className="FolderList__edit" onClick={(e) => this.handleStartEditing(e, folder)}><i className="fa fa-pencil"></i></a> }
                                </span>
                            }
                            
                        </li>
                    })}
                </ul>
                { FolderStore.isDeleting && this.renderDelete() }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/FolderList/FolderList.js